import Vue from 'vue'
import Router from 'vue-router'

import Index from "@/views/index.vue"
import NewList from "@/views/home/newList.vue"
import productDetail from "@/views/home/productDetail.vue"
import society from "@/views/home/society.vue"
import contact from "@/views/home/contact.vue"
import Context from "@/views/home/context.vue"
import businessList from "@/views/home/businessList.vue"
import businessList1 from "@/views/home/businessList1.vue"
import businessDetail from "@/views/home/businessDetail.vue"
import companyInfo from "@/views/home/companyInfo.vue"
import caseDetail from "@/views/home/caseDetail.vue"
import caseList from "@/views/home/caseList.vue"
import deliver from "@/views/home/deliver.vue"
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/newList',
    name: 'newList',
    component: NewList
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: productDetail
  },
  {
    path: '/society',
    name: 'society',
    component: society
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/context',
    name: 'context',
    component: Context
  },
  {
    path: '/businessList',
    name: 'businessList',
    component: businessList
  },
  {
    path: '/businessDetail',
    name: 'businessDetail',
    component: businessDetail
  },{
    path: '/businessList1',
    name: 'businessList1',
    component: businessList1
  },{
    path: '/companyInfo',
    name: 'companyInfo',
    component: companyInfo
  },{
    path: '/caseList',
    name: 'caseList',
    component: caseList
  },{
    path: '/caseDetail',
    name: 'caseDetail',
    component: caseDetail
  },{
    path: '/deliver',
    name: 'deliver',
    component: deliver
  }
  
  
  
  ]
})